export const likesCollection = 'like'
export const suggestedSongsCollection = 'suggested-songs'